import { IAskAnswerSchema } from './ask.model';

/**
 * A Contact may be represented by different models depending on where it is used
 * These Contact models come from the server with minor modifications
 * When used in the Wizard, both ContactSchema and TaskMeetingContact are transformed in
 */
export interface IContactSchema {
    id: string;
    userId: string;
    orgId: string;
    name: string;
    firstName: string;
    lastName: string;
    lname: string;
    email: string[];
    domains: string[];
    defaultEmail: string;
    telephone: string[];
    gtalk: string[];
    twitter: string;
    skype: string;
    organization: string;
    title: string;
    dateData: Date | string;
    providerId: string[];
    showcontactDate: Date;
    xref: string;
    imageUrl: string;
    manuallyCreated?: boolean;

    hasEmailOnly?: boolean;
    _id?: any;
    required?: boolean;

    team?: boolean; // does not exist on original schema but may be returned by getContacts
    members?: IContactSchema[];
}

export interface ISimpleContactSchema {
    name?: string;
    title?: string;
    organization?: string;
    email: string[];
    defaultEmail?: string;
    telephone?: string[];
    userId?: string;
    providerId?: string[];
}

export interface ITaskMeetingContact {
    cannotSuggestTimes: boolean;
    contactId: string;
    contactEmails: string[];
    contactName: string;
    contactImageUrl: string;
    providerId: string[];
    timezoneSelected?: string;
    languageSelected?: string;
    dateSelectedStart?: string;
    dateSelectedEnd?: string;
    contactsLocation?: string;
    contactsPlace?: any;
    googleAuth?: any;
    timeslots?: { start: string; end: string }[];
    required?: boolean;
    dateAnswered?: Date;
    answers?: IAskAnswerSchema[];
    declineResponse?: string;
}
